import type { Verdict } from '@finavest/mortgage-math';

/**
 * ⚖️ JURIST-REVIEW PENDING (W6b) — exact wording of the Zinsvergleich
 * disclaimer goes through legal review; change ONLY this const.
 */
export const VERGLEICH_DISCLAIMER =
  'Die angezeigten Zinssätze der genannten Anbieter basieren auf deren öffentlich publizierten ' +
  'Richtsätzen und sind indikativ. Der Finavest-Zinssatz ist eine indikative Topkondition unserer ' +
  'über 20 Finanzierungspartner. Ihr persönlicher Zinssatz kann je nach Tragbarkeit, Belehnung ' +
  'und Objekt abweichen.';

/** Verdict titles + lead copy (DE), straight from the W1 brief. */
export const VERDICT_COPY: Record<Verdict, { title: string; copy: string }> = {
  machbar: {
    title: 'Machbar',
    copy: 'Ihre Finanzierung wirkt grundsätzlich realistisch.',
  },
  knapp: {
    title: 'Knapp, mit Vorbehalt',
    copy: 'Ihre Finanzierung könnte möglich sein, aber Bankwahl und Struktur sind entscheidend.',
  },
  schwierig: {
    title: 'Aktuell schwierig',
    copy: 'Standardfinanzierungen könnten schwierig werden. Eine Spezialprüfung kann sinnvoll sein.',
  },
  spezial: {
    title: 'Spezialprüfung empfohlen',
    copy: 'Aufgrund Ihrer Angaben empfehlen wir eine individuelle Prüfung über passende Finanzierungspartner.',
  },
};

export const DISCLAIMER =
  'Diese Berechnung ist eine unverbindliche Ersteinschätzung und ersetzt keine persönliche Beratung. ' +
  'Die definitive Finanzierung, Kondition und Bankauswahl erfolgt nach Prüfung Ihrer vollständigen Unterlagen ' +
  'durch Finavest und die jeweiligen Finanzierungspartner.';

export const FREE_NOTE =
  'Die Beratung ist für Sie kostenlos. Finavest wird im Erfolgsfall durch den Finanzierungspartner vergütet.';

/** Bump when the consent wording in index.html changes. Stored with every lead. */
export const CONSENT_TEXT_VERSION = 'finavest-consent-2026.1';
